/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * Directive that will handle the cropping of image-blocks, and image-carousel-blocks.
 */
angular.module('bulbApp.contentEditorModule')
  .directive('bulbCroppable', [
    '$log',
    '$timeout',
    'Restangular',
    'BulbAutoSaveService',
    'BulbBusyService',
    'SerialSaveService',
    'UnitStateStore',
    'CONTENT_EDITOR',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    bulbCroppable]);

function bulbCroppable(
  $log,
  $timeout,
  Restangular,
  BulbAutoSaveService,
  BulbBusyService,
  SerialSaveService,
  UnitStateStore,
  CONTENT_EDITOR,
) {
  return {
    require: [
      '^?mediumContentEditor',
      '^contentBlock',
      '^bulbFrame',
      '^?imageBlock',
      '^?imageCarousel',
      '^?imageAsset'],
    link(scope, elem, attrs, ctrls) {

      let contentEditorCtrl = null;
      if (ctrls[0]) {
        contentEditorCtrl = ctrls[0];
      }
      if (contentEditorCtrl && !contentEditorCtrl.page.editing) {
        return;
      }

      const contentBlockCtrl = ctrls[1];
      const frameCtrl = ctrls[2];
      const imageBlockCtrl = ctrls[3];
      const imageCarouselBlockCtrl = ctrls[4];

      let enabled = false;

      let prevFrameState;
      let prevToolbarState;
      // TODO UNDO : how do we undo/redo a crop?

      let unregisterCropSaveHandler;
      let unregisterCropStopHandler;

      const currentBlockType = contentBlockCtrl.contentBlock.blockType;

      let imageElement = null;
      /**
       * This block of code correctly grabs the current image so that we can pass it to cropperjs.
       * It is simple for image blocks, however for image-carousel blocks -- it is a little more involved.
       * This is because the user can dynamically add or remove images. So how do we always grab the correct one?
       * By essentially watching the contentBlock and check the currently displayed image id's.
       */
      if (currentBlockType === 'IMAGE') {
        $timeout(() => {
          imageElement = elem.find('img');
        }, CONTENT_EDITOR.IMAGE_ASSET.IMAGE_ASSET_IMAGE_TIMEOUT);
      } else if (currentBlockType === 'IMAGE_CAROUSEL') {
        scope.$watchCollection('contentBlockCtrl.contentBlock', (newValue, oldValue) => {
          // Update the displayedImageAssetUrl to reflect the correct image url
          $timeout(() => {
            try {
              const imageAsset = newValue.carouselImages[
                contentBlockCtrl.contentBlock.displayedImageIndex].uncroppedImageAsset
                || newValue.carouselImages[contentBlockCtrl.contentBlock.displayedImageIndex].fullImageAsset;
              imageElement = $(`img[id="${imageAsset.id}"]`);
            } catch (error) {
              // During a carousel state re-init, it is possible that
              // contentBlockCtrl.contentBlock.displayedImageIndex doesn't have a value and thus will
              // throw an error on the client. This isn't necessarily bad, however I don't want an error
              // thrown in the console so that is why we do in this case.
            }
          }, CONTENT_EDITOR.IMAGE_ASSET.IMAGE_ASSET_IMAGE_TIMEOUT);
        });
      } else {
        $log.error('currentBlockType is an undefined type.');
      }

      function beginCrop() {

        let uncroppedImageAsset = null;
        if (currentBlockType === 'IMAGE') {
          uncroppedImageAsset = contentBlockCtrl.contentBlock.uncroppedImageAsset
            || contentBlockCtrl.contentBlock.fullImageAsset;
          imageBlockCtrl.updateImageInfo(uncroppedImageAsset);
        } else if (currentBlockType === 'IMAGE_CAROUSEL') {

          const carouselImage = contentBlockCtrl.contentBlock.carouselImages[
            contentBlockCtrl.contentBlock.displayedImageIndex];
          uncroppedImageAsset = carouselImage.uncroppedImageAsset || carouselImage.fullImageAsset;

          // always want to use the uncropped image asset
          imageElement.attr('src', uncroppedImageAsset.url);

          // Remove this class, because it messes up with croppers' css
          imageElement.removeClass('bulb-carousel-display-image');
        } else {
          $log.error('currentBlockType is an undefined type.');
        }

        prevFrameState = frameCtrl.frameState;
        frameCtrl.setFrameState('default');

        elem.addClass('bulb-cropping');

        // Update what toolbar is displayed
        prevToolbarState = contentBlockCtrl.frameElement.attr('toolbar-state');
        contentBlockCtrl.frameElement.attr('toolbar-state', 'crop');

        // This is a work around for iOS that also works on all other platforms. On iOS (specifically iPhones)
        // the selected element is de-selected when the user clicks the toolbar, this results in the updateToolbar()
        // method failing. Here we know we are in the beginning of the crop so we directly set the selected element
        // This method handles the state/toolbar update aswell.
        contentEditorCtrl.insertBlockExtension.selectBlock(elem);
        if (currentBlockType === 'IMAGE') {
          scope.$apply();
        }

        const { cropRectangle } = contentBlockCtrl.contentBlock;
        unregisterCropSaveHandler = scope.$on('command-save', cropSave);
        unregisterCropStopHandler = scope.$on('command-cancel', cropStop);

        const elemWidth = elem.width();
        const scale = elemWidth / uncroppedImageAsset.width;

        imageElement.cropper({
          checkCrossOrigin: false,
          movable: false,
          rotatable: false,
          scalable: false,
          zoomable: false,
          zoomOnTouch: false,
          zoomOnWheel: false,
          // minCropBox sizes are relative to the page, not the image, so we have to scale them
          minCropBoxWidth: 100 * scale, // TODO CLEAN : load this from config
          minCropBoxHeight: 100 * scale, // TODO CLEAN : load this from config
          data: cropRectangle,
        });

        enabled = true;

      }

      function cropSave() {
        // This crop data scales based on image size, so it is exactly what we want.
        const cropData = imageElement.cropper('getData', 'rounded');

        const imagePatch = {
          cropRectangle: {
            x: cropData.x,
            y: cropData.y,
            width: cropData.width,
            height: cropData.height,
          },
        };

        if (currentBlockType === 'IMAGE_CAROUSEL') {
          imagePatch.selectedImageIndex = contentBlockCtrl.contentBlock.displayedImageIndex;
        }
        const index = contentBlockCtrl.contentBlock.displayedImageIndex;

        // Depending on what the current block type is, determines how we send it off to the server.
        SerialSaveService.save({
          showBusy: true,
          save: () => Restangular.one('units', contentBlockCtrl.page.unit.id)
            .one(CONTENT_EDITOR.BLOCK_PATHS[currentBlockType], contentBlockCtrl.contentBlock.id)
            .patch(imagePatch).then((modifiedContentBlock) => {

              if (currentBlockType === 'IMAGE') {
                angular.copy(modifiedContentBlock.plain(), contentBlockCtrl.contentBlock);
                imageBlockCtrl.updateImageInfo();
              } else if (currentBlockType === 'IMAGE_CAROUSEL') {

                scope.$emit('cropped-carousel-image', index);
                imageCarouselBlockCtrl.updateCarouselState(modifiedContentBlock);

              } else {
                $log.error('currentBlockType is an undefined type.');
              }

              // Update share status to reflect that the unit has been edited:
              const ShareTransition = UnitStateStore.getShareTransitionEnum();
              UnitStateStore.transitionShareStatus(ShareTransition.EDIT);

            }),
        });

        cropStop();
      }

      function cropStop() {
        imageElement.cropper('destroy');
        if (currentBlockType === 'IMAGE_CAROUSEL') {
          imageElement.addClass('bulb-carousel-display-image');

          // Need to update back to the cropped image
          const imageAsset = contentBlockCtrl.contentBlock.carouselImages[
            contentBlockCtrl.contentBlock.displayedImageIndex].scaledImageAsset
                   || contentBlockCtrl.contentBlock.carouselImages[
                     contentBlockCtrl.contentBlock.displayedImageIndex].fullImageAsset;

          imageElement.attr('src', imageAsset.url);
        }
        frameCtrl.setFrameState(prevFrameState);
        elem.removeClass('bulb-cropping');
        contentBlockCtrl.frameElement.attr('toolbar-state', prevToolbarState);
        contentEditorCtrl.updateToolbar();
        if (currentBlockType === 'IMAGE') {
          imageBlockCtrl.updateImageInfo();
          scope.$apply();
        }
        unregisterCropSaveHandler();
        unregisterCropStopHandler();
        enabled = false;
      }

      scope.$on('command-crop', () => {
        if (contentBlockCtrl.selected && !enabled) {
          beginCrop();
        }
      });

      scope.$on('selectionChange', (event, selection) => {
        if (!contentBlockCtrl.selected && enabled) {
          // TODO DESIGN : if a crop is in action, do we want to pop up a dialog allowing the user to
          // continue the crop and cancel the selection change, or abort the crop.  Means we need to be able
          // to cancel the selection change somehow.  Right now we just automatically cancel the crop.
          cropStop();
        }
      });

    },
  };
}
